import { getTypeArticleContentPath } from 'site-modules/editorial/utils/content-path';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { getPageOptions } from 'site-modules/editorial/pages/type/article-definition';
import { TwoColumn } from 'site-modules/editorial/pages/type/two-column/two-column';
import { TEMPLATE_KEY_TWO_COLUMN } from 'site-modules/editorial/utils/article-critical-css-keys';

const pages = new Map();
export default ({ type, articleId, chunkName }) => {
  const key = getTypeArticleContentPath(type, articleId);
  let page = pages.get(key);
  if (!page) {
    page = pageDefinition(
      getPageOptions({
        type,
        articleId,
        pageTemplate: TwoColumn,
        criticalCssTemplateKey: TEMPLATE_KEY_TWO_COLUMN,
        chunkName,
      })
    );
    pages.set(key, page);
  }
  return page;
};
